import { useCallback, useEffect, useState } from 'react';
import { eventsApi } from '../lib/api';
import type { EventListItem } from '@shared/types';

export interface EventListFilters {
  from?: string;
  to?: string;
  include_hidden?: boolean;
  include_past?: boolean;
}

export function useEventList(filters: EventListFilters = {}) {
  const [events, setEvents] = useState<EventListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState<string | null>(null);
  const filterKey = JSON.stringify(filters);

  const refresh = useCallback(async () => {
    setErr(null);
    try {
      const parsed = JSON.parse(filterKey) as EventListFilters;
      const { events } = await eventsApi.list(parsed);
      setEvents(events);
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Failed to load events');
    } finally {
      setLoading(false);
    }
  }, [filterKey]);

  useEffect(() => {
    refresh();
    const onFocus = () => refresh();
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [refresh]);

  return { events, loading, err, refresh };
}
